<script setup lang="ts">
import {
  Column,
  Columns,
  Stack,
  Typography,
} from '@apparatix/library/core';

type Props = {
  colHeader?: string;
}

const props = defineProps<Props>();
</script>
<template>
  <Columns>
    <Column>
      <Stack :gap="5">
        <div v-if="Boolean(props.colHeader)" class="flex items-center w-full pb-3 lg:pb-4 border-b border-[var(--p-content-border-color)]">
          <Typography variant="form-heading">
            {{ props.colHeader }}
          </Typography>
        </div>
        <slot name="col" />
      </Stack>
    </Column>
  </Columns>
</template>
